module.exports = __webpack_public_path__ + "30aa5b2e60db40548ec8f081185db147.svg";